import axios from "axios"
import baseUrl from "./base"

const akunApi = {
  updateUmkm: async (token, id, form) => {
    return await axios.post(`${baseUrl}/api/umkm/${id}/update`, form,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  }
}

export default akunApi